$(document).ready(function () {
  const lastUpdatedTxt = document.querySelector(".lastUpdatedTxt");
                
  const etDateString = new Date().toLocaleDateString("en-US", { timeZone: "America/New_York" });
  const etDate = new Date(etDateString);

  etDate.setHours(12, 0, 0, 0);
  
  const day = etDate.getDay();
  
  const diff = (day - 1 + 7) % 7 || 7;
  
  etDate.setDate(etDate.getDate() - diff);
  
  const options = { 
      month: 'long', 
      day: 'numeric', 
      year: 'numeric'
  };
  
  lastUpdatedTxt.innerHTML = etDate.toLocaleDateString('en-US', options);

  jQuery(window).scroll(function() {
    var wScrollTop = jQuery(this).scrollTop();  // Correctly use jQuery(this) to get the window's scroll position
    var fromOffset = 200;

    if (wScrollTop > fromOffset) { 
        jQuery('.header').addClass('sticky');
        jQuery('.section-footer').addClass('sticky');
    } else { 
        jQuery('.header').removeClass('sticky');
        jQuery('.section-footer').removeClass('sticky');
    } 
  });

});
 